import { deleteApi, get, post } from "../GenericServices";

const FlatRateLocation = {
  getFlatRateLocations: (queryString) => {
    return get(`flat-rate-location${queryString !== "" ? `?${queryString}` : ""}`);
  },
  getFlatRateLocation: (id) => {
    return get(`flat-rate-location/${id}`);
  },
  setFlatRateLocation: (data) => {
    return post(`flat-rate-location`, data);
  },
  deleteFlatRateLocation: (id) => {
    return deleteApi(`flat-rate-location/${id}`);
  },
};

export default FlatRateLocation;
